import { type DomainMessages } from './intl'
import { useIsPartnerBulkDeliveryEnabled } from './useIsPartnerBulkDeliveryEnabled'

/**
 * Returns the appropriate page title translation key based on whether the partner
 * has the partner bulk delivery entitlement.
 * For partners with the entitlement, returns the "Equipment data" key;
 * otherwise returns the default "Device accounts" key.
 */
export const usePageTitleKey = (): DomainMessages => {
  const isPartnerBulkDelivery = useIsPartnerBulkDeliveryEnabled()

  return isPartnerBulkDelivery
    ? 'partnerPickDevicesDomain.title.equipmentData'
    : 'partnerPickDevicesDomain.title.new'
}
